import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class DatePickerComponent implements OnInit {

  @Input() disableDates: Array<any> = [];
  @Input() selectedDate: Date = null;
  @Input() maxDate: any = null;
  @Input() minDate: any = null;
  @Output() dateChanged: EventEmitter<any> = new EventEmitter();

  public isCalenderOpen: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  dateInputChanged = (_dateInput: any) => {
    this.dateChanged.emit(_dateInput.target.value);
  }

  calenderAvailableFilter = (d: Date) => {
    const time = d?.getTime();
    if(this.disableDates.length > 0 && d) {
      return !this.disableDates.find((x:any) => x.getTime() == time);
    } else {
      return true;
    }
  }

  onDatePickerClose = () => {
    this.isCalenderOpen = false;
  }

}
